
import { useState } from 'react';

interface UsernameInputProps {
  onSubmit: (username: string) => void;
}

export default function UsernameInput({ onSubmit }: UsernameInputProps) {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!username.trim()) {
      setError('Введите ваш Telegram ник');
      return;
    }

    const cleanUsername = username.trim().replace('@', '');
    
    if (cleanUsername.length < 5) {
      setError('Ник должен содержать минимум 5 символов');
      return;
    }

    if (!/^[a-zA-Z0-9_]+$/.test(cleanUsername)) {
      setError('Ник может содержать только буквы, цифры и _');
      return;
    }

    onSubmit(cleanUsername);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
    setError('');
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#0f0f0f]">
      {/* Telegram Header */}
      <div className="w-full bg-[#212121] px-4 py-3 flex items-center gap-3">
        <div className="w-10 h-10 bg-[#2AABEE] rounded-full flex items-center justify-center">
          <i className="ri-user-search-line text-white text-xl"></i>
        </div>
        <div>
          <h1 className="text-white font-semibold text-base">Введите ваш ник</h1>
          <p className="text-[#8E8E93] text-xs">Шаг 1 из 2</p>
        </div>
      </div>

      <div className="flex-1 flex flex-col justify-between p-4">
        <div className="flex-1 flex flex-col justify-center">
          <div className="mb-8 text-center">
            <div className="w-20 h-20 bg-[#2AABEE] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-at-line text-white text-4xl"></i>
            </div>
            <h2 className="text-xl font-semibold text-white mb-2">
              Ваш Telegram ник
            </h2>
            <p className="text-sm text-[#8E8E93] max-w-xs mx-auto">
              Мы проведём тайное сканирование активности вокруг вашего профиля
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <div className="relative">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#8E8E93] text-lg">
                  @
                </div>
                <input
                  type="text"
                  value={username}
                  onChange={handleChange}
                  placeholder="username"
                  className="w-full bg-[#1C1C1E] text-white placeholder-[#8E8E93] pl-10 pr-4 py-4 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-[#2AABEE] transition-all"
                  onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                />
              </div>
              {error && (
                <div className="mt-2 flex items-center gap-2 text-[#FF3B30] text-sm">
                  <i className="ri-error-warning-line"></i>
                  <span>{error}</span>
                </div>
              )}
            </div>

            <div className="bg-[#1C1C1E] rounded-xl p-4">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-[#2AABEE] text-xl flex-shrink-0 mt-0.5"></i>
                <div className="text-sm text-[#8E8E93] leading-relaxed">
                  <p className="mb-2">Введите ваш Telegram ник без символа @</p>
                  <p className="text-xs">Например: <span className="text-white">ivan_petrov</span></p>
                </div>
              </div>
            </div>

            <div className="bg-[#1C1C1E] rounded-xl p-4">
              <div className="flex items-center justify-between mb-3">
                <span className="text-white text-sm font-medium">Гарантии безопасности</span>
                <i className="ri-shield-check-fill text-[#34C759] text-lg"></i>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-xs text-[#8E8E93]">
                  <i className="ri-check-line text-[#34C759]"></i>
                  <span>Анонимное сканирование</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-[#8E8E93]">
                  <i className="ri-check-line text-[#34C759]"></i>
                  <span>Никто не узнает о проверке</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-[#8E8E93]">
                  <i className="ri-check-line text-[#34C759]"></i>
                  <span>Данные не сохраняются</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full bg-[#2AABEE] text-white font-medium text-base py-4 rounded-xl hover:bg-[#1E96D3] active:bg-[#1A7FB8] transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer mt-6"
        >
          Продолжить
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
      </div>
    </div>
  );
}
